import { Button } from "components/ui/button";
import { cn } from "lib/utils";
import { ReactElement } from "react";

interface Props extends React.ComponentProps<typeof Button> {
  label: string;
  icon?: ReactElement;
  iconDirection?: "left" | "right";
}

const CustomButton = ({
  label,
  className,
  icon,
  iconDirection,
  ...props
}: Props) => {
  return (
    <Button
      className={cn(
        "bg-brand-primary py-5 relative rounded-lg text-base font-bold text-brand-cardtext border-2 border-brand-primary px-4 hover:bg-brand-card hover:cursor-pointer hover:text-brand-primary transition-colors duration-200",
        className
      )}
      {...props}
    >
      <div
        className={`absolute ${
          iconDirection === "left" ? "left-4" : "right-4"
        }`}
      >
        {icon}
      </div>
      <span
        className={`${
          icon ? (iconDirection === "left" ? "pl-6" : "pr-6") : ""
        }`}
      >
        {label}
      </span>
    </Button>
  );
};
export default CustomButton;
